import { useIsBrazilTenant } from '@/hooks/use-is-brazil-tenant'

/**
 * `true` when copy may offer boleto: it exists only on the Brazil tenant's
 * Stripe account, and Checkout rejects the session outright anywhere else.
 *
 * The language half of the rule lives in the locale files, not here. Boleto is
 * a Brazilian instrument with no honest translation — "bank slip" / "bank
 * transfer" name something we do not offer — so only ptBr spells it out; the
 * other languages' `*Boleto` variants deliberately read like the base string.
 */
export function useShowBoletoCopy(): boolean {
  return useIsBrazilTenant()
}
